import React from 'react';
import { Camera, ChevronRight } from 'lucide-react';

/**
 * Компонент боковой панели с популярными камерами в России
 */
const PopularCamerasSidebar = ({ popularCameras }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Camera className="w-5 h-5 mr-2 text-purple-500" />
        Популярные камеры в России
      </h3>

      <div className="space-y-3">
        {popularCameras.slice(0, 6).map((camera, index) => (
          <div 
            key={index} 
            className="p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1 flex items-center">
              <ChevronRight className="w-4 h-4 text-purple-500 mr-1" />
              {camera.make} {camera.model}
            </h4>
            {camera.lens && (
              <p className="text-xs text-gray-600 dark:text-gray-400">
                Популярный объектив: {camera.lens}
              </p>
            )}
          </div>
        ))}
        
        {/* Отечественные камеры */}
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
          <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
            Российские фотокамеры
          </h4>
          <p className="text-xs text-blue-600 dark:text-blue-400">
            Камеры марки "Зенит" производятся на Красногорском заводе им. С.А. Зверева 
            и являются важной частью истории российской фототехники.
          </p>
        </div>
      </div>

      {/* Дополнительная информация */}
      <div className="mt-4 bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
        <p className="text-xs text-gray-600 dark:text-gray-400">
          По данным исследований российского рынка фототехники, 
          самыми популярными брендами фотокамер в России являются Canon, 
          Nikon и Sony, а в сегменте смартфонов — Samsung, Apple и Xiaomi.
        </p>
      </div>
    </div>
  );
};

export default PopularCamerasSidebar;